import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzPpday80 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPDAY_80: Record<
  Exclude<PageIdWoofzPpday80, PageIdWoofzPpday80.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_PPDAY_80_N]: {
    id: PageId.SUBSCRIPTIONS_PPDAY_80_N,
  },
  [PageId.CHAT_UPSELL_PPDAY_80]: {
    id: PageId.CHAT_UPSELL_PPDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_PPDAY_80]: {
    id: PageId.UPSELL_PPDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_PPDAY_80]: {
    id: PageId.DOWNLOAD_PPDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
